import { type SVGProps } from "react";
import { type IconName } from "./icons/types";
import { cn } from '@repo/ui/lib/utils'

import href from "./icons/sprite.svg";
export { href };
export { IconName };
const sizeClassName = {
  font: "size-[1em]",
  xs: "size-3",
  sm: "size-4",
  md: "size-5",
  lg: "size-6",
  xl: "size-7",
} as const;
type Size = keyof typeof sizeClassName;


const childrenSizeClassName = {
  font: "gap-1.5",
  xs: "gap-1.5",
  sm: "gap-1.5",
  md: "gap-2",
  lg: "gap-2",
  xl: "gap-3",
} satisfies Record<Size, string>;
export function Icon({
  name,
  size = "font",
  className,
  title,
  children,
  ...props
}: SVGProps<SVGSVGElement> & {
  name: IconName;
  size?: Size;
  title?: string;
}) {
  if (children) {
    return (
      <span
        className={`inline-flex items-center ${childrenSizeClassName[size]}`}
      >
        <Icon
          name={name}
          size={size}
          className={className}
          title={title}
          {...props}
        />
        {children}
      </span>
    );
  }
  // const symbolId = `${href}#${name}`;
  return (
    <svg
      {...props}
      className={cn(
        sizeClassName[size],
        "inline self-center relative",
        className
      )}
      aria-hidden="true"
      role={title ? "img" : "presentation"}
    >
      {title ? <title>{title}</title> : null}
      <use href={`${href}#${name}`} />
    </svg>
  );
}


